<!-- tabbar-common -->

<template>
  <div class="tabbar-page">
    <van-tabbar :value="active">
      <van-tabbar-item icon="home-o" @click="
        $router.push({
          path: '/common-index',
          query: { cateId: moduleInfo.topCateId },
        })
        ">
        首页
      </van-tabbar-item>
      <van-tabbar-item icon="contact-o" @click="$router.push({ path: 'user-center-index' })" class="budo-12"> 我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "tabbar-travel",

  data() {
    return {
      // active: 0,
      moduleInfo: this.get_mall_module(),
    };
  },

  props: {
    active: { type: Number, default: 0 },
  },
};
</script>

<style lang="scss" scoped></style>
